// @ts-nocheck
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Container, Row, Col } from "react-bootstrap";
import PageLoading from "components/PageLoading";
import SaveSubmitButtons from "../../../components/SaveSubmitButtons/SaveSubmitButtons";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import NotificationToast from "../../../components/NotificationToast/NotificationToast";
import { fetchAllUsuarios } from "../../../services/usuarioService";
import api from "../../../services/api";
import { PATHS } from "../../../routes/paths";
import "./AddUsers.css";

const AddUsers = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("success");
  const [loading, setLoading] = useState(false);

  const [userData, setUserData] = useState({
    email: "",
    name: "",
    cnpj: "",
    sigla: "",
    empresa: "",
    departamento: "",
    perfil: "",
  });

  useEffect(() => {
    const loadUsers = async () => {
      try {
        const usuarios = await fetchAllUsuarios();
        setUsers(usuarios || []);
      } catch (e) {
        console.error("Erro ao carregar usuários existentes:", e);
        setUsers([]);
      }
    };
    loadUsers();
  }, []);

  const handleChange = (e) => {
    setUserData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const buscarUsuarioMicrosoft = async (email) => {
    const sanitized = (email || "").trim();
    try {
      const response = await api.get(
        `/api/usuario/getByEmailEntraId/${sanitized}`,
      );
      return response.data;
    } catch (error) {
      console.error(
        "Erro ao buscar usuário Microsoft pelo backend:",
        error.response?.data || error.message,
      );
      throw new Error("Erro ao buscar usuário Microsoft");
    }
  };

  const handleBlurEmail = async () => {
    if (!userData.email) return;
    setLoading(true);
    try {
      const userMicrosoft = await buscarUsuarioMicrosoft(userData.email);
      const dept = userMicrosoft.departamento || "";
      const isSindicato = dept === "Sindicato";

      setUserData((prevData) => ({
        ...prevData,
        name: userMicrosoft.nome || "",
        empresa: userMicrosoft.empresa || "",
        departamento: dept,
        cnpj: userMicrosoft.cnpj || "",
        sigla: userMicrosoft.sigla || "",
        email: userMicrosoft.email || prevData.email,
        perfil: isSindicato ? "Sindicato" : prevData.perfil,
      }));
    } catch (error) {
      console.error("Erro ao buscar usuário no Microsoft Graph:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = () => setShowModal(true);

  const perfilToId = (perfil) => {
    switch (perfil) {
      case "Administrador TI":
        return { idPerfil: 1, cargo: "Administrador TI" };
      case "Administrador":
        return { idPerfil: 2, cargo: "Administrador" };
      case "Analista":
        return { idPerfil: 3, cargo: "Analista" };
      case "Sindicato":
        return { idPerfil: 4, cargo: "Sindicato" };
      default:
        return { idPerfil: null, cargo: "" };
    }
  };

  const handleConfirmSave = async () => {
    try {
      const { idPerfil, cargo } = perfilToId(userData.perfil) || {};
      if (!idPerfil || !cargo) {
        throw new Error("Perfil inválido ou não selecionado.");
      }

      const usuarioExistente = users.find(
        (u) =>
          (u.email || "").toLowerCase() ===
          (userData.email || "").toLowerCase(),
      );
      if (usuarioExistente) {
        setToastMessage("Email já está cadastrado.");
        setToastType("error");
        setShowToast(true);
        setShowModal(false);
        return;
      }

      const payload = {
        nome: userData.name,
        departamento: userData.departamento,
        cargo,
        email: userData.email,
        idPerfil,
      };

      await api.post("/api/usuario/create", payload);

      setToastMessage("Usuário cadastrado com sucesso!");
      setToastType("success");
      setShowToast(true);
      setShowModal(false);
      navigate(PATHS.MANAGE_USERS);
    } catch (error) {
      setToastMessage("Selecione um perfil Valido.");
      setToastType("error");
      setShowToast(true);
      setShowModal(false);
    }
  };

  const handleCancel = () => navigate(-1);

  const isSindicato = userData.departamento === "Sindicato";

  return (
    <Container className="add-users-container">
      <h1 className="add-users-title">ADICIONAR USUÁRIO</h1>

      {loading ? (
        <PageLoading />
      ) : (
        <>
          <Form className="add-users-form">
            <Row className="gy-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="add-users-label">
                    E-mail do usuário
                  </Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    placeholder="usuario@fiemg.com.br"
                    value={userData.email}
                    onChange={handleChange}
                    onBlur={handleBlurEmail}
                    autoComplete="on"
                    aria-label="E-mail do usuário"
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label className="add-users-label">
                    Nome do usuário
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    placeholder="Digite o nome do usuário"
                    value={userData.name}
                    onChange={handleChange}
                    disabled
                    autoComplete="on"
                    aria-label="Nome do usuário"
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label className="add-users-label">CNPJ</Form.Label>
                  <Form.Control
                    type="text"
                    name="cnpj"
                    value={userData.cnpj}
                    onChange={handleChange}
                    disabled
                    autoComplete="on"
                    aria-label="CNPJ"
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label className="add-users-label">Sigla</Form.Label>
                  <Form.Control
                    type="text"
                    name="sigla"
                    value={userData.sigla}
                    onChange={handleChange}
                    disabled
                    autoComplete="on"
                    aria-label="Sigla"
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label className="add-users-label">Empresa</Form.Label>
                  <Form.Control
                    type="text"
                    name="empresa"
                    placeholder="Digite a empresa"
                    value={userData.empresa}
                    onChange={handleChange}
                    disabled
                    autoComplete="on"
                    aria-label="Empresa"
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label className="add-users-label">
                    Departamento
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="departamento"
                    placeholder="Digite o departamento"
                    value={userData.departamento}
                    onChange={handleChange}
                    disabled
                    autoComplete="on"
                    aria-label="Departamento"
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label className="add-users-label">Perfil</Form.Label>
                  <Form.Select
                    name="perfil"
                    value={userData.perfil}
                    onChange={handleChange}
                    disabled={isSindicato}
                    aria-label="Perfil"
                  >
                    <option value="">
                      {isSindicato
                        ? "Sindicato"
                        : "Selecione o perfil do usuário"}
                    </option>
                    <option value="Administrador">Administrador</option>
                    <option value="Analista">Analista</option>
                    {/* Sindicato fica bloqueado no select; vem do departamento */}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
          </Form>

          <div className="add-users-buttons mt-4">
            <SaveSubmitButtons
              onSave={handleSave}
              onCancel={handleCancel}
              showCancel={true}
              showSubmit={false}
              showSave={true}
              showSaveModalOnPage={false}
            />
          </div>

          <ConfirmationModal
            isOpen={showModal}
            title="Confirmação"
            message="Deseja realmente adicionar este usuário?"
            onConfirm={handleConfirmSave}
            onCancel={() => setShowModal(false)}
          />

          <NotificationToast
            show={showToast}
            onClose={() => setShowToast(false)}
            message={toastMessage}
            type={toastType}
          />
        </>
      )}
    </Container>
  );
};

export default AddUsers;
